import { render, staticRenderFns } from "./userPost.vue?vue&type=template&id=5f2ffa06&"
import script from "./userPost.vue?vue&type=script&lang=js&"
export * from "./userPost.vue?vue&type=script&lang=js&"
import style0 from "./userPost.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports